import { Box, ButtonBase, IconButton } from '@material-ui/core';
import { BodyMeasurements, BodyMeasurementsKey, CalculateClothBodyMeasurementsFromBodyMeasurements, CalculateClothingMeasurementsFromBodyMeasurements, ClothingMeasurements, ClothingMeasurementsKey, ClothingType, CompleteBodyMeasurements, DefaultFollowingMeasurementsForClothingTypeAndFitType, FitType, RoundClothingMeasurementsToHalfPoint, UserBodyMeasurements, getBodyCardFitFamily } from 'common-ts/dist/models/UserMeasurements';
import { closeOverlayAndReset } from '../redux/UIOverlayPersonalSizeRedux';
import { useAppDispatch } from '../reduxhooks';
import { sendWebsiteEventMessage } from '../telegrambotevents';
import PersonalSizeResult from './OverlayViewUniversalSize4Result';
import PersonalSizeDetailHome from './OverlayViewPersonalSizeDetail1Home';
import { openOverlayCreateMeasWithInitialization as openUniversalSizeOverlay } from '../redux/UIOverlayUniversalSizeRedux';
import OverlayViewPersonalFitModifySize from './OverlayViewPersonalSizeDetail2Edit';
import { RegularSizeValue } from 'common-ts/dist/models/Cart';
import { inputBodyMeasurementsForm, postBodyMeasurement } from '../redux/MeasurementsRedux';
import { ArrowBack } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

// Determines which flow is used based on starting parameters
export interface FlowSelectionData {
}

// State data for flow
// Only for UI state, currentUserMeasurement is accessed within component.
export interface FlowStateData {
  nama: string
  currentScreen: string
  key2CategoryResultShown: string
  currentUserBodyMeasurement: UserBodyMeasurements
  currentFlowData: any
}

// Callback to change state data for flow. 
// Only for UI state, currentUserMeasurement is accessed within component.
export interface FlowStateCallback {
  delayedDispatch: (currentScreen: string) => void
  setCurrentFlowData: (newFlowData: any) => void
}

//
// RENDERER 
// Master function that is used to select and pass data to the block 
// selected using the flow selection data.
//
export function FlowComponentMasterPersonalSize(flowSelectionData: FlowSelectionData, 
  flowStateData: FlowStateData, flowStateCallback: FlowStateCallback) {
  
  let children: JSX.Element[] = [];
  children = FlowComponentMensTops(flowSelectionData, flowStateData, flowStateCallback);
  
  // We choose the right block to use with the flow selection data.
  return (
    <Box>
      {
        children
      }
    </Box>
  );
}

function FlowComponentMensTops(flowSelectionData: FlowSelectionData, 
  flowStateData: FlowStateData, flowStateCallback: FlowStateCallback) {
  const dispatch = useAppDispatch();

  let delayedDispatch = flowStateCallback.delayedDispatch;

  let children: JSX.Element[] = [];

  switch (flowStateData.currentScreen) {
    case "ukuranPersonalCurrentDetail":
      children.push(<PersonalSizeDetailHome 
        currentBodyMeasurementObj={flowStateData.currentUserBodyMeasurement}
        handleLihatHasil={() => {
          delayedDispatch('ukuranPersonalCurrentHasilBaju');
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 01. OPEN HASIL baju");
        }}
        handleEditUkuran={() => {

          flowStateCallback.setCurrentFlowData({
            ...flowStateData.currentFlowData,
            newAdjustedMeasurements: undefined,
            lastUpdatedMeasurementsList: undefined,
          })

          delayedDispatch('ukuranPersonalCurrentEdit');
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 01. EDIT ulang ukuran personal");
        }}
        handleClose={() => {
          dispatch(closeOverlayAndReset());
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 01. TUTUP detail ukuran personal");
        }}
        handleBuatUlang={() => {
          dispatch(closeOverlayAndReset());
          dispatch(openUniversalSizeOverlay({ productOnUser: undefined, flowVariant: 'advanced' }));
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 01. BUAT ULANG ukuran personal");
        }}
      />
      )
      break;
    case "ukuranPersonalCurrentEdit":
      const usedMeas = flowStateData.currentFlowData?.newAdjustedMeasurements ?? flowStateData.currentUserBodyMeasurement.adjustedMeasurements as any;
      children.push(
      <Box style={{margin: '21px'}}>
        {/* <Box
          style={{
            position: 'absolute',
            top: '12px',
            left: '12px',
            borderRadius: '50%',
            padding: '6px',
          }}
          onClick={() => {
            
            flowStateCallback.setCurrentFlowData({
              ...flowStateData.currentFlowData,
              newAdjustedMeasurements: undefined,
              lastUpdatedMeasurementsList: undefined,
            })

            delayedDispatch('ukuranPersonalCurrentDetail');
            sendWebsiteEventMessage("[PERSONAL FIT EDIT] 01. Edit screen - BACK");
          }}
        >
          <IconButton style={{
            padding: '0',
            color: 'black',
          }}>
            <ArrowBack />
          </IconButton>
        </Box> */}
        <Box style={{height: '30px', width: '100%'}}></Box>
        <Box style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          zIndex: 2000,
        }}
          onClick={() => {
            flowStateCallback.setCurrentFlowData({
              ...flowStateData.currentFlowData,
              newAdjustedMeasurements: undefined,
              lastUpdatedMeasurementsList: undefined,
            })

            dispatch(closeOverlayAndReset());
            // delayedDispatch('ukuranPersonalCurrentDetail');
            // sendWebsiteEventMessage("[PERSONAL FIT EDIT] 01. Edit screen - BACK");
          }}
        >
          <ButtonBase
            style={{
              backgroundColor: '#ffffff',
              color: '#232323',
              padding: '4px',
              borderRadius: '40px'
            }}>
            <CloseIcon/>
          </ButtonBase>
        </Box>
        <OverlayViewPersonalFitModifySize
          startingClothingBodyMeasurements={ // B-complete, CB-optional
            CompleteBodyMeasurements(usedMeas, 
              RegularSizeValue.L)}
          startingClothingBodyMeasurementsCBComplete={ // CB-complete
            CalculateClothBodyMeasurementsFromBodyMeasurements(ClothingType.Body, 
              FitType.RegularFit, 
              usedMeas, 
              RegularSizeValue.L, [])}
          startingClothingMeasurements={ // AUTOCOMPLETE THE CB. USE CB-COMPLETE
            RoundClothingMeasurementsToHalfPoint(
            CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, 
              FitType.RegularFit, 
              usedMeas, 
              RegularSizeValue.L))}
          startingRawClothingMeasurements={ // AUTOCOMPLETE THE CB. USE CB-COMPLETE
            CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, 
              FitType.RegularFit, 
              usedMeas, 
              RegularSizeValue.L)}
          handleSubmit={(value, valueClothing, lastUpdatedMeasurementsList) => {

            // TODO STILL SOMEWHAT BUGGY.
            // SHOULD WE ALSO COMBINE LAST UPDATED MEASUREMENT LIST BEFORE?
            if (Object.keys(lastUpdatedMeasurementsList)?.length) {
              flowStateCallback.setCurrentFlowData({
                ...flowStateData.currentFlowData,
                newAdjustedMeasurements: value,
                lastUpdatedMeasurementsList: lastUpdatedMeasurementsList,
              })
            } else {
              flowStateCallback.setCurrentFlowData({
                ...flowStateData.currentFlowData,
                newAdjustedMeasurements: value,
                lastUpdatedMeasurementsList: flowStateData.currentUserBodyMeasurement?.lastUpdatedMeasurementsList ?? {}, // USE PREVIOUS VALUE 
              })
            }

            delayedDispatch("ukuranPersonalCurrentHasilEditBaju");
          }}
          isMinimized={false}
        />
      </Box>);
      break;
    case "ukuranPersonalCurrentHasilEditBaju":
      const triggerList1: {[key: string]: {
        clothingMeasurementsKey: string // Same as the key for this dictionary
        bodyMeasurementsKey: string,
        triggerText: string
        triggerCallback: () => void
        showMeasurementAs?: 'SIZEWHEEL' | 'NUMBER'
      }} = {};
      triggerList1[ClothingMeasurementsKey.panjangLenganPendek as string] = {
        clothingMeasurementsKey: ClothingMeasurementsKey.panjangLenganPendek as string,
        bodyMeasurementsKey: BodyMeasurementsKey.panjangLenganPendek as string,
        triggerText: "",
        triggerCallback: () => {
        },
        showMeasurementAs: flowStateData.currentFlowData.newAdjustedMeasurements?.[BodyMeasurementsKey.panjangLenganPendek] ? 'NUMBER' : undefined,
      }
      triggerList1[ClothingMeasurementsKey.lebarLenganBaju as string] = {
        clothingMeasurementsKey: ClothingMeasurementsKey.lebarLenganBaju as string,
        bodyMeasurementsKey: BodyMeasurementsKey.lingkarLenganBisep as string,
        triggerText: "",
        triggerCallback: () => {
        },
        showMeasurementAs: flowStateData.currentFlowData.newAdjustedMeasurements?.[BodyMeasurementsKey.lebarLenganPendek] ? 'NUMBER' : undefined,
      }
      children.push(<PersonalSizeResult
        name={flowStateData.currentUserBodyMeasurement?.nama ? flowStateData.currentUserBodyMeasurement.nama : 'User'}
        bodyMeasurements={flowStateData.currentFlowData.newAdjustedMeasurements ?? {}}
        firstClothingType={(flowStateData?.key2CategoryResultShown?.split('-')?.[0] as ClothingType) ?? flowStateData.currentFlowData?.clothingType ?? ClothingType.Kaos}
        firstFitType={(flowStateData?.key2CategoryResultShown?.split('-')?.[1] as FitType) ?? flowStateData.currentFlowData?.fitType ?? FitType.SlimFit}
        lastUpdatedMeasurementsList={flowStateData.currentFlowData.lastUpdatedMeasurementsList ?? {}}
        buttonTextType={'result-detail'}
        handleBack={() => {
          delayedDispatch('ukuranPersonalCurrentEdit');
          sendWebsiteEventMessage("[PERSONAL FIT EDIT] 03. Result shown - BACK");
        }}
        handleSubmit={() => {  
          if (!flowStateData?.currentFlowData?.newAdjustedMeasurements) {
            // delayedDispatch('ukuranPersonalCurrentDetail');
            dispatch(closeOverlayAndReset());
            return;
          }
          const newTimestamp = new Date().toISOString();
          const userMeasurements: UserBodyMeasurements = {
            ...flowStateData.currentUserBodyMeasurement,
            // creationDateTime: newTimestamp,
            updateDateTime: newTimestamp,
            previousVersionCreationDateTime: flowStateData.currentUserBodyMeasurement.creationDateTime,
            adjustedMeasurements: flowStateData.currentFlowData.newAdjustedMeasurements,
            lastUpdatedMeasurementsList: flowStateData.currentFlowData.lastUpdatedMeasurementsList,
            // Pin the edited card to its own fit family (legacy cards = STANDARD). The draft
            // is merged (Object.assign), so a spread without fitType would let a leftover
            // value from an earlier edit in the same session survive.
            fitType: getBodyCardFitFamily(flowStateData.currentUserBodyMeasurement),
          };
          dispatch(inputBodyMeasurementsForm(userMeasurements));

          dispatch(postBodyMeasurement(''));

          // delayedDispatch('ukuranPersonalCurrentDetail');
          dispatch(closeOverlayAndReset());
          sendWebsiteEventMessage("[PERSONAL FIT EDIT] 03. Result shown - NEXT");
        }}
        triggerList={triggerList1}
      />);
      break;
    case "ukuranPersonalCurrentHasilBaju":
      const triggerList: {[key: string]: {
        clothingMeasurementsKey: string // Same as the key for this dictionary
        bodyMeasurementsKey: string,
        triggerText: string
        triggerCallback: () => void
        showMeasurementAs?: 'SIZEWHEEL' | 'NUMBER'
      }} = {};
      if (!flowStateData.currentUserBodyMeasurement.adjustedMeasurements?.[BodyMeasurementsKey.panjangLenganPanjang]) {
        triggerList[ClothingMeasurementsKey.panjangLenganPanjang as string] = {
          clothingMeasurementsKey: ClothingMeasurementsKey.panjangLenganPanjang as string,
          bodyMeasurementsKey: BodyMeasurementsKey.panjangLenganPanjang as string,
          triggerText: "ATUR",
          triggerCallback: () => {
            flowStateCallback.setCurrentFlowData({
              ...flowStateData.currentFlowData,
              newAdjustedMeasurements: undefined,
              lastUpdatedMeasurementsList: undefined,
            })
  
            delayedDispatch('ukuranPersonalCurrentEdit');
            sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 01. Result shown - ATUR panjangLenganPanjang");
          }
        }
      }
      triggerList[ClothingMeasurementsKey.panjangLenganPendek as string] = {
        clothingMeasurementsKey: ClothingMeasurementsKey.panjangLenganPendek as string,
        bodyMeasurementsKey: BodyMeasurementsKey.panjangLenganPendek as string,
        triggerText: "ATUR",
        triggerCallback: () => {
          flowStateCallback.setCurrentFlowData({
            ...flowStateData.currentFlowData,
            newAdjustedMeasurements: undefined,
            lastUpdatedMeasurementsList: undefined,
          })

          delayedDispatch('ukuranPersonalCurrentEdit');
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 01. Result shown - ATUR panjangLenganPendek");
        },
        showMeasurementAs: flowStateData.currentUserBodyMeasurement.adjustedMeasurements?.[BodyMeasurementsKey.panjangLenganPendek] ? 'NUMBER' : undefined,
      }
      triggerList[ClothingMeasurementsKey.lebarLenganBaju as string] = {
        clothingMeasurementsKey: ClothingMeasurementsKey.lebarLenganBaju as string,
        bodyMeasurementsKey: BodyMeasurementsKey.lingkarLenganBisep as string,
        triggerText: "ATUR",
        triggerCallback: () => {
          flowStateCallback.setCurrentFlowData({
            ...flowStateData.currentFlowData,
            newAdjustedMeasurements: undefined,
            lastUpdatedMeasurementsList: undefined,
          })

          delayedDispatch('ukuranPersonalCurrentEdit');
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 01. Result shown - ATUR lebarLenganPendek");
        },
        showMeasurementAs: flowStateData.currentUserBodyMeasurement.adjustedMeasurements?.[BodyMeasurementsKey.lebarLenganPendek] ? 'NUMBER' : undefined,
      }
      children.push(<PersonalSizeResult
        name={flowStateData.currentUserBodyMeasurement?.nama ? flowStateData.currentUserBodyMeasurement.nama : 'User'}
        bodyMeasurements={flowStateData.currentUserBodyMeasurement.adjustedMeasurements ?? {}}
        firstClothingType={(flowStateData?.key2CategoryResultShown?.split('-')?.[0] as ClothingType) ?? flowStateData.currentFlowData?.clothingType ?? ClothingType.Kaos}
        firstFitType={(flowStateData?.key2CategoryResultShown?.split('-')?.[1] as FitType) ?? flowStateData.currentFlowData?.fitType ?? FitType.SlimFit}
        buttonTextType={'result-detail'}
        useCloseButton={true}
        handleBack={() => {
          dispatch(closeOverlayAndReset());
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 03. Result shown - BACK");
        }}
        handleUbahUkuran={() => {
          delayedDispatch('ukuranPersonalCurrentEdit');
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 01. Result shown - ATUR ukuran");
        }}
        handleSubmit={() => {  
          // delayedDispatch('ukuranPersonalCurrentDetail');
          dispatch(closeOverlayAndReset());
          sendWebsiteEventMessage("[PERSONAL FIT DETAIL] 03. Result shown - NEXT, WE CLOSE");
        }}
        triggerList={triggerList}
      />);
      break;
  }

  return children;
}